<template lang="html">
    <div class="tab-panel padded">

        <div class="form-group row" v-if="currentOta">
            <!-- Cancellation policy -->
            <div class="col-sm-12">
                <h5><span class="text-uppercase">{{otaName}}</span> INTEGRATIONs</h5>

                <div class="d-flex flex-column">
                    <div>
                        <span>Allow to cancel bookings </span>
                        <input type="number" style="width: 65px;" v-model="cancellationPolicy"></input>
                        <span>hour(s) or more before booked activity takes place.</span>
                    </div>

                    <div class="bg-red-pale p-2 my-3 fs-small">
                        The cancellation policy is agreed between the parties. When making changes make sure you and GetYourGuide agree on the cancellation period set.
                    </div>

                </div>

            </div>

            <div class="col-sm-12 mt-3">
                <h5><span class="text-uppercase">{{otaName}}</span> INTEGRATIONs</h5>

                <div class="d-flex flex-row">


                    <div class="d-flex flex-grow-1">
                        <div v-html="textSmall"></div>
                    </div>

                    <div class="d-flex">
                        <a :href="helpLink" target="_blank">
                            <button class="btn cancel wider">Instructions Guide</button>
                        </a>
                    </div>

                </div>

                <div class="mt-3" :is="integrationComponent" :ota="currentOta">
                </div>

            </div>
        </div>

    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
    created: function () {
        this.getOTAByChannelType(this.otaChannelType).then(ota => {
            this.currentOta = ota
        })
    },
    props:{
        otaChannelType:{
            type: Number
        },
        agent: {
            type: Object
        }
    },
    data: function() {
        return {
            currentOta: null,
        }
    },
    computed:{
        cancellationPolicy:{
            get() {
                return this.agent.cancelationPolicyInMinutes / 60
            },
            set(val) {
                this.agent.cancelationPolicyInMinutes = val * 60
            }
        },
        otaLogo: function () {
            return this.currentOta.logo
        },
        otaName: function () {
            return this.currentOta.name
        },
        textSmall: function () {
            return this.currentOta.integration.textSmall
        },
        helpLink: function () {
            return this.currentOta.integration.helpLink
        },
        integrationComponent: function () {
            return this.currentOta.integration.integrationComponent
        }
    },
    methods: {
        ...mapActions([
            'getOTAByChannelType'
        ])
    }
}
</script>

<style lang="scss" scoped>
// @import '~@/assets/scss/_variables.scss';
</style>



// WEBPACK FOOTER //
// AgentOtaSettings.vue?984c2ff8